import { DarwinFlex } from 'components/darwin-ui';
import { RoleSections } from '.';
import styles from '../Roles.module.css';
import { useTranslation } from 'react-i18next';

type EditRoleSectionProps = {
  section: RoleSections;
  setSection: (section: RoleSections) => void;
};

export const EditRoleSection: React.FC<EditRoleSectionProps> = ({
  section,
  setSection,
}) => {
  const { t } = useTranslation();

  const handleSectionClick = (sectionName: RoleSections) => {
    setSection(sectionName);
  };

  return (
    <DarwinFlex
      align="center"
      justify="start"
      vertical
      className={styles.editRoleColumn}
    >
      <button
        className={`${styles.section} ${section === RoleSections.RoleDetails ? styles.active : ''}`}
        onClick={() => handleSectionClick(RoleSections.RoleDetails)}
      >
        <h2>{t('roles.role-form.role-details')}</h2>
        <p>{t('roles.role-form.role-details-description')}</p>
      </button>

      <button
        className={`${styles.section} ${section === RoleSections.AssociatedProducts ? styles.active : ''}`}
        onClick={() => handleSectionClick(RoleSections.AssociatedProducts)}
      >
        <h2>{t('roles.role-form.associated-products')}</h2>
        <p>{t('roles.role-form.associated-products-description')}</p>
      </button>

      <button
        className={`${styles.section} ${section === RoleSections.AssociatedProcesses ? styles.active : ''}`}
        onClick={() => handleSectionClick(RoleSections.AssociatedProcesses)}
      >
        <h2>{t('roles.role-form.associated-processes')}</h2>
        <p>{t('roles.role-form.associated-processes-description')}</p>
      </button>

      <button
        className={`${styles.section} ${section === RoleSections.AssociatedUsers ? styles.active : ''}`}
        onClick={() => handleSectionClick(RoleSections.AssociatedUsers)}
      >
        <h2>{t('roles.role-form.associated-users')}</h2>
        <p>{t('roles.role-form.associated-users-description')}</p>
      </button>

      <button
        className={`${styles.section} ${section === RoleSections.Permissions ? styles.active : ''}`}
        onClick={() => handleSectionClick(RoleSections.Permissions)}
      >
        <h2>{t('roles.role-form.permissions')}</h2>
        <p>{t('roles.role-form.permissions-description')}</p>
      </button>
    </DarwinFlex>
  );
};
